import React from 'react';
import '../styles/Hero.css';
import { FaGithub, FaLinkedin, FaTwitter, FaInstagram, FaEnvelope } from 'react-icons/fa';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-name">
            Hi, I'm <span className="highlight">Atharv Untwale</span>
          </h1>
          <p className="hero-description">
            Full Stack Developer | Creative Problem Solver | Tech Enthusiast
            <br />
            Crafting elegant solutions with modern web technologies
          </p>
          <div className="hero-buttons">
            <a href="#projects" className="btn btn-primary">
              View Projects
            </a>
            <a 
              href="https://drive.google.com/file/d/1lly4ipsOGeu2oCKqWxiQGoyDMalQ5m5S/view?usp=sharing" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-secondary"
            >
              Download CV
            </a>
          </div>
          
          {/* Social Links */}
          <div className="social-links">
            <a 
              href="https://x.com/atharvuntwale20" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Twitter"
            >
              <FaTwitter />
            </a>
            <a 
              href="https://www.linkedin.com/in/atharv-untwale/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </a>
            <a 
              href="https://github.com/Atharv-Untwale" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="GitHub"
            >
              <FaGithub />
            </a>
            <a 
              href="https://www.instagram.com/atharvuntwale/?hl=en" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a 
              href="mailto:atharvuntwale38@gmial.com" 
              className="social-icon"
              aria-label="Email"
            >
              <FaEnvelope />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;